import { ButtonLoadingContent, loadingButtonClass } from "@/components/buttons/ButtonLoadingContent";
import { Spinner } from "@/components/ui/spinner";

type AuthSubmitButtonProps = {
    id: string;
    label: string;
    loading?: boolean;
};

const AuthSubmitButton = ({ id, label, loading = false }: AuthSubmitButtonProps) => {
    return (
        <button
            id={id}
            type="submit"
            aria-busy={loading || undefined}
            className={loadingButtonClass(loading, "gs-auth-submit-btn")}
        >
            <ButtonLoadingContent
                loading={loading}
                loaderId={`${id}-loader`}
                spinner={
                    loading ? (
                        <Spinner
                            id={`${id}-loader`}
                            size="sm"
                            className="gs-btn-loading-spinner absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white"
                        />
                    ) : undefined
                }
            >
                {label}
            </ButtonLoadingContent>
        </button>
    );
};

export default AuthSubmitButton;
